import { Identity } from "@pdfking/tfunc"
import { CmykToRgb } from "./CmykToRgb"
import { CreateColorConvert } from "./CreateColorConvert"
import { HslToRgb } from "./HslToRgb"

/**
 * Converts a Color to an RGBColor
 * If the input is already RGB, it will be returned as is
 * If the input is CMYK or HSL, it will be converted to RGB
 */
export const ToRgb = CreateColorConvert(Identity, CmykToRgb, HslToRgb)
